import React, { useMemo, useState } from 'react';
import { block, getQaAttrubutes } from '../../utils';
import YoutubeBlock from '../VideoBlock/VideoBlock';
import DataLens from './DataLens/DataLens';
import FullscreenVideo from './FullscreenVideo/FullscreenVideo';
import Iframe from './Iframe/Iframe';
import Image from './Image/Image';
import Video from './Video/Video';
import './Media.css';
const b = block('Media');
export const Media = (props) => {
    const { image, video, youtube, dataLens, color, height, previewImg, parallax = false, fullscreen, analyticsEvents, className, imageClassName, videoClassName, youtubeClassName, disableImageSliderForArrayInput, playVideo = true, isBackground, playButton, customBarControlsClassName, qa, ratio, autoplay, onImageLoad, iframe, margins, } = props;
    const [hasVideoFallback, setHasVideoFallback] = useState(false);
    const qaAttributes = getQaAttrubutes(qa, 'video');
    const content = useMemo(() => {
        let result = [];
        if (image) {
            result.push(React.createElement(Image, { key: "image", parallax: parallax, image: image, disableImageSliderForArrayInput: disableImageSliderForArrayInput, height: height, imageClassName: imageClassName, isBackground: isBackground, video: video, hasVideoFallback: hasVideoFallback, fullscreen: fullscreen, qa: qaAttributes.image, onLoad: onImageLoad }));
        }
        if (video) {
            const videoProps = {
                key: 'video',
                video,
                videoClassName,
                height,
                analyticsEvents,
                playVideo,
                previewImg,
                playButton,
                customBarControlsClassName,
                hasVideoFallback,
                setHasVideoFallback,
                ratio,
            };
            if (fullscreen) {
                result.push(React.createElement(FullscreenVideo, Object.assign({}, videoProps, { qa: qaAttributes.video })));
            }
            else {
                result.push(React.createElement(Video, Object.assign({}, videoProps, { qa: qaAttributes.video })));
            }
        }
        if (youtube) {
            result = (React.createElement(YoutubeBlock, { className: b('youtube', youtubeClassName), record: youtube, attributes: { color: 'white', rel: '0' }, previewImg: previewImg, height: height, fullscreen: fullscreen, analyticsEvents: analyticsEvents, autoplay: autoplay, onImageLoad: onImageLoad }));
        }
        if (dataLens) {
            result = React.createElement(DataLens, { dataLens: dataLens });
        }
        if (iframe) {
            result = React.createElement(Iframe, { iframe: iframe, margins: margins });
        }
        return result;
    }, [
        image,
        video,
        youtube,
        dataLens,
        iframe,
        parallax,
        disableImageSliderForArrayInput,
        height,
        imageClassName,
        isBackground,
        hasVideoFallback,
        fullscreen,
        qaAttributes.image,
        qaAttributes.video,
        onImageLoad,
        videoClassName,
        analyticsEvents,
        playVideo,
        previewImg,
        playButton,
        customBarControlsClassName,
        ratio,
        youtubeClassName,
        autoplay,
        margins,
    ]);
    return (React.createElement("div", { className: b(null, className), style: { backgroundColor: color }, "data-qa": qa }, content));
};
export default Media;
